import Type from './Type';
export function isISpan(node) {
    return node.type === Type.Span;
}
export default isISpan;    //# sourceMappingURL=isISpan.js.map
